import React from 'react';
import styled from 'App/styled';
import MobileIcon from 'components/Icons/Mobile';
import StorePlay from 'components/Icons/StorePlay';
import StoreApp from 'components/Icons/StoreApp';

const AppLinksWrapper = styled.div`
  background-color: ${(props) => props.theme.newsletterBak};
  color: #ffffff;
  ${({ theme }) => theme.typography.subTitleSmall};
  padding: 0 30px 0;
  text-transform: uppercase;
  text-align: center;
`;

const AppBox = styled.p`
  margin-bottom: 10px;
`;

const AppIcon = styled.i`
  margin-right: 10px;
  svg {
    vertical-align: middle;
  }
`;

const AppBtn = styled.div`
  margin: 0;
  padding: 0;
`;

const AppLink = styled.a`
  margin: 0 3px;
  display: inline-block;
`;

interface AppLinksProps {
  appLinkEnabled: boolean;
  appLinks: { [key: string]: string };
}

const AppLinks = (props: AppLinksProps) => {
  const { appLinkEnabled, appLinks } = props;

  if (!appLinkEnabled) return null;

  return (
    <AppLinksWrapper>
      <AppBox>
        <AppIcon aria-hidden="true">
          <MobileIcon />
        </AppIcon>
        <span>{appLinks?.title}</span>
      </AppBox>
      <AppBtn>
        <AppLink
          className="playstore"
          href={appLinks?.googlePlay}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StorePlay />
        </AppLink>
        <AppLink
          className="aapstore"
          href={appLinks?.appStore}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StoreApp />
        </AppLink>
      </AppBtn>
    </AppLinksWrapper>
  );
};

export default AppLinks;
